<template>
    <button :id="id" :type="type" :class="finalClass" :disabled="disabled" @click="$emit('click')">
        <slot />
    </button>
</template>

<script>
export default {
    name: 'BaseButton',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
        id: {
            type: String,
            default: '',
        },
    },
    computed: {
        defaultClass() {
            return [
                'rounded',
                'font-medium',
                'transition',
                'duration-150',
                'ease-in-out',
                'focus:outline-none',
                'focus:ring',
                'disabled:opacity-50',
                'disabled:cursor-not-allowed',
            ].join(' ');
        },
        finalClass() {
            return [this.defaultClass, this.customClass].join(' ').trim();
        },
    },
};
</script>
